import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

import { NotAvailablePipe } from '@shared/pipes';

import { TextWithPlaceholderComponent } from '../text-with-placeholder/text-with-placeholder.component';

@Component({
  selector: 'app-details-item',
  templateUrl: './details-item.component.html',
  styleUrls: ['./details-item.component.scss'],
  standalone: true,
  imports: [TextWithPlaceholderComponent, NgClass, NotAvailablePipe],
})
export class DetailsItemComponent {
  @Input() label = '';

  @Input() value?: string | null;

  @Input() valueColor?: string | null;

  @Input() tooltip?: string | null;

  @Input() noBreak = false;

  @Input() noWrapLabel = false;

  @Input() showPlaceholder = true;

  @Input() height = '1.125';

  @Input() width?: string;

  @Input() placeholderRows = 1;

  @Input() templateValueOnly = false;

  @Input() isSmallOffset = false;

  @Input() noOffset = false;

  @Input() fullWidth = false;

  @Input() labelStyle: 'bold' | 'normal' = 'normal';

  get placeholderWidth(): string {
    return this.width ?? `${this.label.split('').length}`;
  }

  get minHeight(): number {
    const placeholderHeight = 1.4375;
    if (!this.showPlaceholder && !this.value) {
      return placeholderHeight;
    }

    return placeholderHeight * this.placeholderRows;
  }

  get valueClass(): string {
    return this.valueColor ? 'details-item-value--' + this.valueColor : '';
  }
}
